export const insertTable = "wXb";
export default {insertTable};